/**
 * Tabs on Radix (CLAUDE.md: tabs go through ui/, built on Radix; arrow keys, Home/End
 * and roving focus are Radix's). DESIGN.md §Tabs: an underline row, 14px/600 muted
 * labels 24px apart over a 1px divider; the current tab in text colour with a 2px
 * underline. Scrolls sideways when it overflows.
 */
import React, { forwardRef } from "react";
import * as RadixTabs from "@radix-ui/react-tabs";
import { cn } from "./cn";

export const Tabs = RadixTabs.Root;

export const TabsList = forwardRef(function TabsList(
  { className, ...props },
  ref,
) {
  return (
    <RadixTabs.List
      ref={ref}
      className={cn(
        "tw-mb-6 tw-flex tw-gap-6 tw-overflow-x-auto tw-border-0 tw-border-b tw-border-solid tw-border-divider",
        className,
      )}
      {...props}
    />
  );
});

export const TabsTrigger = forwardRef(function TabsTrigger(
  { className, ...props },
  ref,
) {
  return (
    <RadixTabs.Trigger
      ref={ref}
      className={cn(
        "tw-relative tw-whitespace-nowrap tw-border-0 tw-border-b-2 tw-border-solid tw-border-transparent tw-bg-transparent tw-px-0 tw-py-3",
        "tw-text-sm tw-font-semibold tw-text-text-muted tw-cursor-pointer max-rail:tw-min-h-11",
        "hover:tw-text-text aria-selected:tw-border-text aria-selected:tw-text-text",
        "focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-focus-ring",
        className,
      )}
      {...props}
    />
  );
});

export const TabsContent = forwardRef(function TabsContent(
  { className, ...props },
  ref,
) {
  return (
    <RadixTabs.Content
      ref={ref}
      className={cn(
        "focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-focus-ring",
        className,
      )}
      {...props}
    />
  );
});
